import useAnalytics from "./hooks/useAnalytics";

const Analytics = () => {
  useAnalytics();
  return null;
};

export default Analytics;
